import React from 'react';

interface LmsContainerProps {
  children: React.ReactNode;
  header?: React.ReactNode;
}
export const LmsContainer = ({ children, header: head }: LmsContainerProps) => {
  return (
    <div className="flex w-full flex-col pt-6 xl:px-5">
      {head && <header className="px-5 pb-0 xl:px-0">{head}</header>}
      <div className="my-5 flex flex-col gap-x-1 bg-white p-4 shadow-none xl:rounded-lg xl:p-4 xl:pt-6 xl:shadow-card">
        {/* <div className="my-5 bg-white py-4 xl:rounded-lg xl:p-4 xl:pt-6 xl:shadow-card"> */}
        {children}
      </div>
    </div>
  );
};
